import { CodebaseProductData } from '../types/models';
import { MediaResource } from '@/components/models';
import { getRegionValue } from '@/composables/regionHelpers';

type LocalisedMedia = {
  carousel?: MediaResource[];
  featureImage?: MediaResource;
  doubleWide?: MediaResource;
  selectorImage?: MediaResource;
  customProductAsset?: {
    bundleImage?: MediaResource;
    upsellImage?: MediaResource[];
  };
};

export const useStoreMediaLocaliseHelper = (
  media: CodebaseProductData['media'],
): LocalisedMedia => ({
  carousel: media.carousel ? getRegionValue(media.carousel) : undefined,
  featureImage: media.featureImage ? getRegionValue(media.featureImage) : undefined,
  doubleWide: media.doubleWide ? getRegionValue(media.doubleWide) : undefined,
  selectorImage: media.selectorImage ? getRegionValue(media.selectorImage) : undefined,
  customProductAsset: media.customProductAsset
    ? {
        bundleImage: media.customProductAsset.bundleImage
          ? getRegionValue(media.customProductAsset.bundleImage)
          : undefined,
        upsellImage: media.customProductAsset.upsellImage
          ? getRegionValue(media.customProductAsset.upsellImage)
          : undefined,
      }
    : undefined,
});
